module.exports = __webpack_public_path__ + "d70b4354759a0977baa8b0002fa30e31.svg";